<app-section id="community" ornament="right">
	<span headline i18n="community@@community.headline">Community</span>
	<section class="community">
		<div class="">
			<h5 i18n="Discuss@@community.discuss.headline">Discuss</h5>
			<div class="explainText" i18n="talk@@community.discuss.explaintext">We’d love to talk to you!</div>
			<div class="row justify-content-center">
				<a href="https://bit.ly/Arkheim_Discord" target="_blank" angulartics2On="click" angularticsAction="openDiscordButton" angularticsCategory="socialmedia">
					<div class="boxContainer discord" >
						<div class="icon">
							<i class="fab fa-discord fa-5x"></i>
						</div>
						<div class="name" i18n="discord@@community.discuss.discord">Discord</div>
					</div>
				</a>
			</div>
		</div>
		<h5 class="mt-3" i18n="followus@@community.follow.headlien">Follow us</h5>
		<div class="row  justify-content-center">
			<a href="https://www.facebook.com/Arkheim-1987316651338494/" target="_blank" angulartics2On="click" angularticsAction="openFacebookButton" angularticsCategory="socialmedia">
				<div class="facebook boxContainer">
					<div class="icon">
						<i class="fab fa-facebook fa-5x"></i>
					</div>
					<div class="name" i18n="facebook@@community.follow.facebook">Facebook</div>
				</div>
			</a>
			<a href="https://bit.ly/Arkheim_YT" target="_blank" angulartics2On="click" angularticsAction="openYoutubeButton" angularticsCategory="socialmedia">
				<div class="youtube boxContainer">
					<div class="icon">
						<i class="fab fa-youtube fa-5x"></i>
					</div>
					<div class="name" i18n="youtube@@community.follow.youtube">Youtube</div>
				</div>
			</a>
		</div>
	</section>
	<section class="register text-center">
		<!--
		<div class="row">
			<div class="col-lg-6 container" angulartics2On="click" angularticsAction="preReg_inlineForm_click" angularticsCategory="preregistration">
				<h5 i18n="Pre-Register@@community.preregister.headline">Pre-Register</h5>
				<div class="innerContainer">
					<div class="welcomeText" i18n="Pre-Register@@community.register.welcometext">Enter your email address below to join the Closed Beta!</div>
					<platform-preregister-form></platform-preregister-form>
				</div>
			</div>
		-->
		<div class="row">
			<div class="col-lg-6 container">
				<h5 i18n="CreateAccount@@community.register.headline">Create Account</h5>
				<div class="innerContainer">
					<div class="welcomeText" i18n="Pre-Register@@community.preregister.headline">Explore and conquer the world of Arkheim. All worlds will die in the end but your glory will shine forever!</div>
					<register-button *ngIf="!env.settings.preRegOnly" angulartics2On="click" angularticsAction="reg_openPopup_keyart" angularticsCategory="registration"></register-button>
					<preregister-button *ngIf="env.settings.preRegOnly" angulartics2On="click" angularticsAction="prereg_openPopup_keyart" angularticsCategory="preregistration"></preregister-button>
					<!-- <register-form></register-form>-->
				</div>
			</div>
		</div>

	</section>
	<section class="createdBy text-center pt-4">
		<div class="py-3">Created by</div>
		<div>
			<a class="" href="http://www.traviangames.com/" target="_blank" angulartics2On="click" angularticsAction="travianGamesLogo" angularticsCategory="navigation">
				<img src="assets/logos/tg-logo3.png" height="46px" alt="Travian Games GmbH Logo">
			</a>
		</div>
		<div class="pt-3">
			© 2019 Travian Games GmbH. All rights reserved.
		</div>

	</section>
</app-section>
